// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchRelecently{border:0!important;background:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.14);padding:0 0 10px 0!important}", ""]);
// Exports
module.exports = exports;
